export const contactsData = {
    address: '17000, La Rochelle, FR',
} as const;